import React, {memo, useMemo, useCallback} from 'react';
import PropTypes from 'prop-types';
import {Button, Dropdown, Menu, Tooltip} from 'antd';
import {DownloadOutlined, FileExcelOutlined, FilePdfOutlined} from '@ant-design/icons';
import {useTranslation} from 'react-i18next';
import useExport from '@/hooks/useExport';
import kebabCase from 'lodash/kebabCase';
import moment from 'moment';
import fileDownload  from 'js-file-download';

const FORMATS = {
  EXCEL: 'excel',
  PDF: 'pdf',
};

const ICONS = {
  [FORMATS.EXCEL]: <FileExcelOutlined/>,
  [FORMATS.PDF]: <FilePdfOutlined/>,
};

const EXT = {
  [FORMATS.EXCEL]: '.xlsx',
  [FORMATS.PDF]: '.pdf',
};

const ExportButton = ({translation, service, prefix}) => {
  const {t} = useTranslation(translation);

  const {loading, exportFile} = useExport(service);

  const handleChange = useCallback(async ({key: format}) => {
    const data = await exportFile(format);
    const name = `${kebabCase(prefix)}-${moment().format('DD/MM/YYYY-HH:mm:SSS').toString()}${EXT[format]}`;

    if(data) {
      fileDownload (data, name);
    }
  }, [exportFile, prefix]);

  const menu = useMemo(() => (
    <Menu onClick={handleChange}>
      {Object.values(FORMATS).map((f) => (
        <Menu.Item key={f}>{ICONS[f]} {t(`export.${f}`)}</Menu.Item>
      ))}
    </Menu>
  ), [handleChange, t]);

  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <Tooltip title={t('export.title')}>
        <Button icon={<DownloadOutlined/>} type={'default'} loading={loading}/>
      </Tooltip>
    </Dropdown>
  );
};

export default memo(ExportButton);

ExportButton.propTypes = {
  translation: PropTypes.string,
  service: PropTypes.func,
  prefix: PropTypes.string,
};

ExportButton.defaultProps = {
  translation: 'common',
  service: x => x
};
